var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_vm.cls,attrs:{"aria-hidden":"true","viewBox":_vm.icon.viewBox},domProps:{"innerHTML":_vm._s(_vm.icon.body)}})
}
var staticRenderFns = []

export { render, staticRenderFns }